<template>
  <div class="app-sort" @click="sort">
    <slot></slot>
    <span class="sort-icon">
      <i :class="{ active: value == 'asc' }" class="el-icon-caret-top"></i>
      <i :class="{ active: value == 'desc' }" class="el-icon-caret-bottom"></i>
    </span>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    label: String,
    value: {
      type: String,
      validator: function (value) {
        return ['asc', 'desc', ''].includes(value)
      }
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    sort() {
      let res = "asc";
      switch (this.value) {
        case "asc":
          res = "desc";
          break;
      }
      this.$emit("change", res);
    },
  },
};
</script>
<style scoped lang="less">
.app-sort {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: #262626;
  line-height: 24px;
  .sort-icon {
    display: inline-flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    font-size: 80%;
    line-height: 50%;
    .active {
      color: #368fff;
    }
  }
  .el-icon-caret-top {
    margin-bottom: -3px;
  }
  .el-icon-caret-bottom {
    margin-top: -3px;
  }
}
</style>